module.exports = __webpack_public_path__ + "img/Rl_Log_new.875ec2cc.svg";